import styled, {css} from 'styled-components'

export const TooltipWrapper = styled.span<{$inline?: boolean}>`
  display: ${({$inline}) => ($inline ? 'inline-block' : 'block')};
  width: ${({$inline}) => ($inline ? 'auto' : '100%')};
  position: relative;
`

export const TooltipBubble = styled.div<{
  $placement: 'top' | 'bottom' | 'left' | 'right'
  $align: 'start' | 'center' | 'end'
  $maxWidth?: number
  $nowrap?: boolean
}>`
  position: absolute;
  z-index: 1000;
  max-width: ${({$maxWidth, $nowrap}) =>
    $nowrap ? 'min(90vw, 640px)' : $maxWidth ? `${$maxWidth}px` : '280px'};
  ${({$nowrap}) =>
    $nowrap &&
    css`
      width: max-content;
      white-space: nowrap;

      & * {
        white-space: nowrap;
      }
    `};
  padding: 6px 8px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.85);
  color: white;
  font-size: 12px;
  line-height: 16px;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transform: translateY(0);
  transition: opacity 120ms ease, visibility 120ms ease, transform 120ms ease;

  ${({$placement, $align}) =>
    $placement === 'top' &&
    css`
      bottom: 100%;
      ${$align === 'start' &&
      css`
        left: 0;
        transform: translate(0, -4px);
      `}
      ${$align === 'center' &&
      css`
        left: 50%;
        transform: translate(-50%, -4px);
      `}
      ${$align === 'end' &&
      css`
        right: 0;
        left: auto;
        transform: translate(0, -4px);
      `}
    `}
  ${({$placement, $align}) =>
    $placement === 'bottom' &&
    css`
      top: 100%;
      ${$align === 'start' &&
      css`
        left: 0;
        transform: translate(0, 4px);
      `}
      ${$align === 'center' &&
      css`
        left: 50%;
        transform: translate(-50%, 4px);
      `}
      ${$align === 'end' &&
      css`
        right: 0;
        left: auto;
        transform: translate(0, 4px);
      `}
    `}
  ${({$placement}) =>
    $placement === 'left' &&
    css`
      right: 100%;
      top: 50%;
      transform: translate(-4px, -50%);
    `}
  ${({$placement}) =>
    $placement === 'right' &&
    css`
      left: 100%;
      top: 50%;
      transform: translate(4px, -50%);
    `}

  ${TooltipWrapper}:hover &,
  ${TooltipWrapper}:focus-within & {
    opacity: 1;
    visibility: visible;
  }
`
